import Dinero from 'dinero.js'

export const slugify = value => value.toLowerCase().replace(/[\s\W-]+/g, '-')

export const ucfirst = value => (value && _.isString(value))
    ? value.charAt(0).toUpperCase() + value.slice(1)
    : (value || '');

export const capitalize = value => (value && _.isString(value))
    ? value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
    : (value || '');

export const titleCase = value => value.replace(/\w[^\s-\_]*/g, capitalize)

export const currency = (amount, currency, locale = 'en-GB') => {
    return Dinero({ amount: Math.round(amount * 100), currency })
        .setLocale(locale)
        .toFormat('£0,0.00');
}

export const truncate = (value, length) => {
    if(value && _.isString(value)){
        if(value.length <= length){
            return value
        }

        return value.slice(0,length)+'...'
    }

    return value || ''
}

export const toCurrency = (value, currency = 'GBP', decimals = 2) => {
    if (typeof value !== "number") {
        return value;
    }

    if (currency === false) {
        var formatter = new Intl.NumberFormat('en-UK', {
            minimumFractionDigits: decimals
        });
    } else {
        var formatter = new Intl.NumberFormat('en-UK', {
            style: 'currency',
            currency: currency,
            minimumFractionDigits: decimals
        });
    }

    return formatter.format(value);
}

export const booleanToString = value => value ? 'Yes' : 'No';

export const uuid = () => 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
})

export const resolveNumericText = (str, absolute = true) => {
    let exp = (('' + str).split(/([\/\*\+\-\(\)])/).map((i) => i.replace(/[^0-9.\(\)\/\+\-\*]+/g, '')).join(''))
    let ret = 0
    try {
        ret = eval(exp)
    } catch (e) {
        ret += (str.replace(/[^0-9.-]/g, ''))
    }
    ret = isNaN(ret) ? 0 : ret
    return absolute ? Math.abs(ret) : ret
}
